import script from "./GameParametersForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GameParametersForm.vue?vue&type=script&setup=true&lang=js"

import "./GameParametersForm.vue?vue&type=style&index=0&id=7cc44991&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc44991"]])

export default __exports__